import { Icon, IconProps } from "./archive";

export const PawnshopIcon = (props: IconProps) => {
  return (
    <Icon {...props} fill="currentcolor">
      <>
        <path d="M6.2 4.5V5.4H5.3V6.3H4.4V7.2H3.5V9.9H21.5V7.2H20.6V6.3H19.7V5.4H18.8V4.5H6.2Z" />
        <path d="M5.3 10.8H7.1V15.3H12.5V10.8H14.3V18.9H5.3V10.8Z" />
        <path d="M19.7 18.9V10.8H17.9V18.9H19.7Z" />
      </>
    </Icon>
  );
};
